import React, { useState } from "react";
import ACwarningPicto from "../../../images/AC/AC_Alert.svg";
import CONSTANTS from "../../../constants";
import ForfaitRevisionItemFlex from "./forfaitRevisionItemFlex";
import Button from "../../Forms/Button";
import { pushEventToGTM } from "../../../helpers/trackerManager";
import PopUp from "../../popup/popup";
import { connect } from "react-redux";
import "./besoinsDetailsListRevisionFlex.scss";

const mapStateToProps = (state) => state;

const BesoinsDetailsListRevisionFlex = (props) => {
  const [selectedData, setSelectedData] = useState(
    props.data ? props.data : {}
  );
  const [numberOfselected, setNumberOfselected] = useState(
    props.numberOfselected ? props.numberOfselected : 0
  );
  const [selectedForfait, setSelectedForfait] = useState(0);
  const [
    showObligatoryOperationsPopup,
    setShowObligatoryOperationsPopup,
  ] = useState(false);
  const [TotalPrice, setTotalPrice] = useState(false);
  const currencyPlacement = !!Number(window.siteConfig.PoundPlacement);
  let numberOfSelectedOperations = 0;

  const selectThatForfait = (isChecked, id, isOperation = false) => {
    // this function add "isSelected (bool)" to selected forfaits and opearations(sous forfaits).
    let number = numberOfselected;
    let data = JSON.parse(JSON.stringify(selectedData));
    const dataUpdatedWithSelectedForfaits = data.map(function(forfaitType) {
      forfaitType.SubFunctionList[0].ForfaitList = forfaitType.SubFunctionList[0].ForfaitList.map(
        function(forfait) {
          // Check Forfaits
          if (!isOperation) {
            if (forfait.Items[0].Ref == id) {
              forfait["isSelected"] = true;
              number++;
            } else {
              forfait["isSelected"] = false;
            }
          }
          // Check Operations
          if (forfait.Operations != null) {
            forfait.Operations = forfait.Operations.map(function(Operation) {
              if (Operation.Items[0].Ref == id)
                if (isChecked) {
                  Operation["isSelected"] = true;
                } else {
                  Operation["isSelected"] = false;
                }
              return Operation;
            });
          }
          return forfait;
        }
      );
      return forfaitType;
    });
    setSelectedData(dataUpdatedWithSelectedForfaits);
    setNumberOfselected(number);
  };

  const checkObligatoryOperations = () => {
    let _selectedForfait =
      selectedData[0].SubFunctionList[0].ForfaitList !== null &&
      selectedData[0].SubFunctionList[0].ForfaitList.filter(
        (forfait) => forfait.isSelected
      );
    let operations = _selectedForfait[0].Operations;
    let selectedOperations =
      operations !== null &&
      operations.filter((operation) => operation.isSelected);
    numberOfSelectedOperations = selectedOperations.length;
    if (operations !== null && !numberOfSelectedOperations) {
      setShowObligatoryOperationsPopup(true);
    } else {
      props.getSelectedForfait(selectedData);
    }
  };

  const popInObligatoryOperationsContent = (
    <React.Fragment>
      <div className="warning-content">
        <div className="warning-label1">
          {CONSTANTS.LABELS.needs_basket_maintenance_alert_label1}
        </div>
        <div className="warning-list">
          <div className="warning-label2">
            {CONSTANTS.LABELS.needs_basket_maintenance_alert_label2}
          </div>
          <div className="warning-label3">
            {CONSTANTS.LABELS.needs_basket_maintenance_alert_label3}
          </div>
        </div>
      </div>
    </React.Fragment>
  );

  const getFinalPrice = (priceToDisplay) =>
    currencyPlacement
      ? CONSTANTS.LABELS.common_v2_currency +
        priceToDisplay +
        ` ${CONSTANTS.LABELS.needs_basket_label2}`
      : priceToDisplay +
        ` ${CONSTANTS.LABELS.common_v2_currency}` +
        ` ${CONSTANTS.LABELS.needs_basket_label2}`;

  return (
    <div className="rootRevisionContainer">
      <div className="revisionFlexContainer">
        {selectedData.map(
          (forfaitType) =>
            Object.values(forfaitType.SubFunctionList).length > 0 &&
            forfaitType.SubFunctionList[0].ForfaitList.map((forfait, index) => (
              <ForfaitRevisionItemFlex
                data={forfait}
                key={forfait.Items[0].Ref}
                enableAddButton={() => setNumberOfselected(1)}
                familyCode={forfaitType.SubFunctionList[0].Code}
                updateSelectedForfait={(isChecked, ref) => {
                  setSelectedForfait(ref);
                  selectThatForfait(isChecked, ref);
                }}
                updateSelectedOperation={(isChecked, ref) => {
                  selectThatForfait(isChecked, ref, true);
                }}
                selectedForfait={selectedForfait}
                TotalPrice={TotalPrice}
                setTotalPrice={setTotalPrice}
                index={index}
              />
            ))
        )}

        <div className="buttonTotalPriceContainer">
          <Button
            classes={numberOfselected < 1 ? "disabled" : ""}
            onClick={() => {
              checkObligatoryOperations();
              pushEventToGTM({
                pageName: "services",
                eventAction: "Click::CTA",
                eventLabel: "operations_add_revision",
              });
            }}
            Disabled={numberOfselected < 1}
          >
            {CONSTANTS.LABELS.common_v2_add}
          </Button>

          {!!selectedForfait && (
            <React.Fragment>
              <div className="totalPriceContainer">
                {!!Number(props.store.booking.happy) && (
                  <div className="discountPrice">
                    {getFinalPrice(TotalPrice)}
                  </div>
                )}

                <div className="finalPriceContainer">
                  <div className="priceLabel">
                    {CONSTANTS.LABELS.needs_basket_maintenance_label9}
                  </div>
                  <div className="priceNumber">
                    {!!Number(props.store.booking.happy)
                      ? getFinalPrice(
                          (
                            TotalPrice -
                            TotalPrice * 0.01 * props.store.booking.happy
                          ).toFixed(2)
                        )
                      : getFinalPrice(TotalPrice)}
                  </div>
                </div>

                {props.store.booking.happy && (
                  <div className="discountRate">{`${props.store.booking.happy}%`}</div>
                )}
              </div>
            </React.Fragment>
          )}
        </div>

        <p
          dangerouslySetInnerHTML={{
            __html: CONSTANTS.LABELS.needs_basket_label4,
          }}
        ></p>
      </div>

      {// show popup if no obligatory operation  is selected
      showObligatoryOperationsPopup && (
        <PopUp
          title={CONSTANTS.LABELS.needs_basket_maintenance_alert_title}
          titlePicto={{
            showTitlePicto: true,
            src: ACwarningPicto,
            alt: "warning",
            width: window.isMobile() === "desktop" ? "192px" : "96px",
          }}
          showTitlePicto={true}
          content={popInObligatoryOperationsContent}
          primaryButtonLabel={
            CONSTANTS.LABELS.needs_basket_maintenance_alert_choose
          }
          secondaryButtonLabel={
            CONSTANTS.LABELS.needs_basket_maintenance_alert_ignore
          }
          handlePrimaryButton={() => setShowObligatoryOperationsPopup(false)}
          handleSecondaryButton={() => props.getSelectedForfait(selectedData)}
        />
      )}
    </div>
  );
};

export default connect(mapStateToProps)(BesoinsDetailsListRevisionFlex);
